import { brandName } from './brand';

// Panelden yazılan metinlerdeki yer tutucular (footer sayfaları, footer metni,
// üst bant, sponsorluk metni). Tablo **tek yerdedir**: bir yüzeyde çalışan yer
// tutucunun diğerinde çalışmaması yöneticinin metni kopyalayınca ham
// `{{...}}` görmesine yol açardı.
//
// **Alan adı ayar kaydından okunmaz, tarayıcıdan gelir.** Kurulumun domaini
// sık değişir (`marinabet103` → `marinabet104`) ve sayfa metnine elle yazılmış
// adres domainle birlikte güncellenmez — oyuncuya artık var olmayan bir adres
// gösterilirdi (bkz. CLAUDE.md → *Alan adı değişince adresler geride kalır*).
// `window.location` her zaman sitenin o an açıldığı adrestir, yani metin
// domain değişse de kendiliğinden doğrudur.
//
// Tanınmayan bir yer tutucu **olduğu gibi kalır**: yöneticinin yazım hatası
// sessizce metni yemesin, ekranda görünsün.

const text = (value) => String(value ?? '').trim();

const location = () => (
  typeof window !== 'undefined' && window.location ? window.location : null
);

// Görünen adres `www.` taşımaz: metinde "www.ornek.com" ile "ornek.com"un
// karışması markayı iki farklı adres gibi gösterirdi.
const siteDomain = () => text(location()?.hostname).replace(/^www\./i, '');

const siteUrl = () => {
  const domain = siteDomain();
  if (!domain) return '';
  const protocol = text(location()?.protocol) || 'https:';
  // Yerel geliştirmede port olmadan adres açılmaz.
  const port = text(location()?.port);
  const suffix = port && port !== '80' && port !== '443' ? `:${port}` : '';
  return `${protocol}//${domain}${suffix}`;
};

const RESOLVERS = {
  site_name: (settings) => brandName(settings),
  site_domain: () => siteDomain(),
  site_url: () => siteUrl(),
  contact_email: (settings) => text(settings.contact_email),
  contact_phone: (settings) => text(settings.contact_phone),
  telegram_url: (settings) => text(settings.telegram_url),
  instagram_url: (settings) => text(settings.instagram_url),
  whatsapp_url: (settings) => text(settings.whatsapp_url),
  year: () => String(new Date().getFullYear()),
};

// Panelin yardım listesi bu tablodan çizilir; yeni yer tutucu eklendiğinde
// yönetici onu ayrıca öğrenmek zorunda kalmaz.
export const TEXT_PLACEHOLDERS = [
  { key: 'site_name', label: 'Site adı' },
  { key: 'site_domain', label: 'Alan adı (otomatik)' },
  { key: 'site_url', label: 'Site adresi (otomatik)' },
  { key: 'contact_email', label: 'İletişim e-postası' },
  { key: 'contact_phone', label: 'İletişim telefonu' },
  { key: 'telegram_url', label: 'Telegram adresi' },
  { key: 'instagram_url', label: 'Instagram adresi' },
  { key: 'whatsapp_url', label: 'WhatsApp adresi' },
  { key: 'year', label: 'İçinde bulunulan yıl' },
];

const PLACEHOLDER_RE = /\{\{\s*([a-z_]+)\s*\}\}/gi;

// Değeri boş kalan bir **etiket satırı** tümüyle düşer: panelde Telegram
// adresi tanımlı değilken sayfada "Telegram:" yazan boş bir satır kalırdı.
// Ölçü bilinçli olarak dardır — yalnızca iki nokta ile biten kısa bir satır —
// çünkü paragrafın ortasındaki boş bir marka adı paragrafı silmemelidir.
const EMPTY_LABEL_LINE = /^\s*(?:[-•*]\s*)?[^:<>{}]{1,48}:\s*$/;

const renderLine = (line, settings) => {
  let emptied = false;
  const rendered = line.replace(PLACEHOLDER_RE, (match, name) => {
    const resolve = RESOLVERS[String(name).toLowerCase()];
    if (!resolve) return match;
    const value = resolve(settings) || '';
    if (!value) emptied = true;
    return value;
  });
  if (emptied && EMPTY_LABEL_LINE.test(rendered)) return null;
  return rendered;
};

// Marka henüz bilinmiyorsa (ayarlar gelmedi, önbellek boş) şablon boşa çevrilir;
// "Site" gibi bir yer tutucu yazmak yanlış bir marka göstermek olurdu.
export const renderSettingText = (value, settings = {}) => (
  String(value || '')
    .split('\n')
    .map((line) => renderLine(line, settings || {}))
    .filter((line) => line !== null)
    .join('\n')
);
